<div class="upload-button-conrtainer">
    <button mat-flat-button class="hds-button" (click)="openHandler()">Upload New <mat-icon>add</mat-icon></button>
</div>